// Tells the backend this is the internal dashboard, so SSO login and /logout use
// the separate admin-auth-token cookie instead of the customer app's auth-token.
export const INTERNAL_APP_HEADER = { "X-Coverflow-App": "internal" } as const;

export async function get<T>(
  url: string,
  options?: RequestInit
): Promise<{ status: number; body: T }> {
  // credentials: "include" so the admin-auth-token cookie set by SSO login (see
  // pages/SSOCallback) rides along automatically — harmless for the legacy
  // admin-token header flow, which ignores cookies entirely on the backend.
  const headers = new Headers(options?.headers);
  headers.set("X-Coverflow-App", INTERNAL_APP_HEADER["X-Coverflow-App"]);
  const response = await fetch(url, { credentials: "include", ...options, headers });
  const body = await response.json().catch(() => ({}));
  return {
    status: response.status,
    body,
  };
}
